/**
 *
 * LanguageProvider.js
 *
 * This component connects the user's locale to the IntlProvider component and provides the application
 * the i18n messages (found in the translations folder).
 */

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'
import { importLanguage, formatTranslationMessages } from '../i18n'
import useLocale from '../hooks/useLocale'

const LanguageProvider = ({ children, defaultMessages }) => {
  const locale = useLocale()
  const [language, setLanguage] = useState(locale.language)
  const [translationMessages, setTranslationMessages] = useState(
    defaultMessages && defaultMessages[language] ? defaultMessages : undefined
  )

  useEffect(() => {
    if (!translationMessages || locale.language !== language) {
      changeLanguage(locale.language)
    }
  }, [locale.language])

  const changeLanguage = language => {
    importLanguage(language).then(messages => {
      setTranslationMessages({
        ...translationMessages,
        [language]: formatTranslationMessages(messages),
      })
      setLanguage(language)
    })

    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', language)
    }
  }

  if (!language || !translationMessages || !translationMessages[language]) {
    return null
  }

  return (
    <IntlProvider
      key={language}
      locale={language}
      messages={translationMessages[language]}
      textComponent="span"
    >
      {React.Children.only(children)}
    </IntlProvider>
  )
}

LanguageProvider.propTypes = {
  children: PropTypes.element.isRequired,
  defaultMessages: PropTypes.object,
}
export default LanguageProvider
